<template>
    <list-page-shell title="审核中">
        <order-workbench
            :show-title="false"
            :show-announcement-columns="false"
            :hide-primary-actions="true"
            :show-create-button="false"
            :extra-query-params="{ review_list: 1 }"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'ReviewList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/ReviewList.vue